/*
 * Constants.
 */

const hoverParentClass = 'front-hover-parent';
const hoverClass = 'front-hover';

export const hoverSelector = buildHoverSelector();
export const directHoverSelector = buildDirectHoverSelector();

/*
 * Methods.
 */

export function buildHoverSelector(pseudoElement = '') {
  return `
    .${hoverParentClass}:hover &&${pseudoElement},
    .${hoverParentClass}.${hoverClass} &&${pseudoElement}
  `;
}

/**
 * Same as `buildHoverSelector`, with the ancestor sitting inside `:is(:where(...) *)` so the
 * selector's subject stays the styled component itself. It therefore nests inside other blocks,
 * combines with further conditions on the same element
 * (`${buildParentWhereHoverSelector()}:not([data-x])`), and carries no specificity of its own —
 * `:where()` zeroes the ancestor, and `*` zeroes the descendant — leaving the component's own states
 * to win by source order rather than by a specificity ladder.
 *
 * @param pseudoElement An optional pseudo element to target, such as `::before`.
 * @return The selector, to be interpolated in a styled component.
 */
export function buildParentWhereHoverSelector(pseudoElement = '') {
  return `&:is(:where(.${hoverParentClass}:hover, .${hoverParentClass}.${hoverClass}) *)${pseudoElement}`;
}

// TODO do we need such an aggressive selector?
export function buildDirectHoverSelector(pseudoElement = '') {
  return `
    &.${hoverParentClass}:hover${pseudoElement},
    &.${hoverParentClass}.${hoverClass}${pseudoElement},
    .${hoverParentClass}:hover > &&${pseudoElement},
    .${hoverParentClass}.${hoverClass} > &&${pseudoElement}
  `;
}

export function buildHoverParentClassName(hasHover?: boolean, baseClassName: string = '') {
  const className = `${hoverParentClass}${baseClassName && ` ${baseClassName}`}`;
  return hasHover ? `${hoverClass} ${className}` : className;
}
